import { useRef } from 'react'
import { FormattedMessage } from 'react-intl'
import { View } from 'react-native'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import formMsgs from '../../../elements/forms/messages'
import { H1, Paragraph, Text, TextLink } from '../../../elements/typography'
import { ChangePlanLink } from '../ChangePlanLink/ChangePlanLink.js'
import { ChosenPlanDescription } from '../ChosenPlanDescription/ChosenPlanDescription.js'
import messages from '../messages'
import { AgreeingToTerms } from './AgreeingToTerms'

const Container = styled(View)`
  padding: 0 ${(props) => props.theme.spacing.medium}px;
  margin: ${(props) => props.theme.spacing.xlarge}px 0;
  align-items: center;
`

const FormContainer = styled(View)`
  max-width: 340px;
  margin: 0 auto;
`

const OrSignIn = styled(Text)`
  margin-bottom: ${(props) => props.theme.spacing.medium}px;
  align-self: flex-start;
`

const LastWords = styled(Paragraph)`
  font-weight: ${(props) => props.theme.fontWeights.bold};
  text-align: center;
`

export const RegisterAccount = ({
  headingMsg = messages.signUpFinalStep,
  authStatus,
  chosenPlan = {},
  onRequestChange,
  onPressSignIn,
  onPressTerms,
  onPressPolicy,
  children,
}) => {
  // Keep track of whether the user was already registered when reaching this page
  // in which case the sign-in link is hidden
  const existingUserRef = useRef(authStatus)
  return (
    <Container>
      <H1 center>
        <FormattedMessage {...headingMsg} />
      </H1>

      <ChosenPlanDescription chosenPlan={chosenPlan} />

      <ChangePlanLink onRequestChange={onRequestChange} />

      <FormContainer>
        {!existingUserRef.current?.hasSignedIn && (
          <OrSignIn>
            <FormattedMessage
              {...messages.createAccountOrSignIn}
              values={{
                signInLink: (
                  <TextLink onPress={onPressSignIn}>
                    <FormattedMessage {...formMsgs.signIn} />
                  </TextLink>
                ),
              }}
            />
          </OrSignIn>
        )}

        {children}

        {chosenPlan?.hasFreeTrial && (
          <LastWords>
            <FormattedMessage {...messages.noCommitCancel} />
          </LastWords>
        )}

        <AgreeingToTerms onPressPolicy={onPressPolicy} onPressTerms={onPressTerms} />
      </FormContainer>
    </Container>
  )
}

RegisterAccount.ChangePlanLink = ChangePlanLink

RegisterAccount.propTypes = {
  chosenPlan: PropTypes.object.isRequired,
  onRequestChange: PropTypes.func.isRequired,
  onPressSignIn: PropTypes.func.isRequired,
  onPressTerms: PropTypes.func.isRequired,
  onPressPolicy: PropTypes.func.isRequired,
}
